import edit_button from "../edit_button.html";

export default function (nga, admin) {
  var combo = admin.getEntity("Combos");
  combo
    .listView()
    .title(
      '<h4>Products & Services <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>'
    )
    .batchActions([])
    .fields([
      nga.field("id", "string").isDetailLink(false).label("ID"),
      nga.field("product_id", "string").isDetailLink(false).label("Product ID"),
      nga.field("name", "string").isDetailLink(false).label("Name"),
      nga.field("duration").cssClasses("hidden-xs").label("Duration"),
      nga.field("value", "number").cssClasses("hidden-xs").label("Value"),
      nga
        .field("bouquet_type", "choice")
        .choices([
          { value: 0, label: "Base" },
          { value: 1, label: "Addon" },
          { value: 2, label: "Ale Carte" },
        ])
        .cssClasses("hidden-xs")
        .label("Bouquet type"),
      nga.field("isavailable", "boolean").label("Available"),
    ])
    .filters([
      nga.field('q')
      .label('')
      .template('<div class="input-group"><input type="text" ng-model="value" placeholder="Search" class="form-control"><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
      .pinned(true),
    ])
    .listActions(["edit"])
    .exportFields([combo.listView().fields()]);

  combo
    .creationView()
    .onSubmitSuccess([
      "progression",
      "notification",
      "$state",
      "entry",
      "entity",
      function (progression, notification, $state, entry, entity) {
        progression.done();
        $state.go($state.get("edit"), {
          entity: entity.name(),
          id: entry._identifierValue,
        });
        return false;
      },
    ])
    .title(
      '<h4>Products & Services <i class="fa fa-angle-right" aria-hidden="true"></i> Create: Product</h4>'
    )
    .fields([
      nga
        .field("product_id", "string")
        .attributes({ placeholder: "Product ID" })
        .validation({ required: true })
        .label("Product ID"),
      nga
        .field("name", "string")
        .attributes({ placeholder: " Name of your product" })
        .validation({ required: true })
        .label("Name"),
      nga
        .field("duration")
        .attributes({ placeholder: "Duration of this product in days" })
        .validation({ required: true })
        .label("Duration"),
      nga
        .field("value", "number")
        .attributes({ placeholder: "Price of the product" })
        .validation({ required: true })
        .label("Value"),

      nga
        .field("bouquet_type", "choice")
        .choices([
          { value: 0, label: "Base" },
          { value: 1, label: "Addon" },
          { value: 2, label: "Ale Carte" },
        ])
        .attributes({ placeholder: "Bouquet Type" })

        .validation({ required: false })
        .label("Bouquet type"),
      nga
        .field("box_type", "choice")
        .choices([
          { value: 1, label: "HD" },
          { value: 0, label: "SD" },
        ])
        .attributes({ placeholder: "Box Quality" })

        .validation({ required: false })
        .label("Box type"),
      nga
        .field("isavailable", "boolean")
        .attributes({ placeholder: "Is Available" })
        .validation({ required: true })
        .label("Is Available"),
      nga.field("template").label("").template(edit_button),
    ]);

  combo
    .editionView()
    .actions(["list"])
    .title(
      '<h4>Products & Services <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.name }}</h4>'
    )
    .fields([
      combo.creationView().fields(),
      nga
        .field("", "referenced_list")
        .label("Prices")
        .targetEntity(admin.getEntity("comboPrices"))
        .targetReferenceField("combo_id")
        .targetFields([
          nga
            .field("price_id", "reference")
            .targetEntity(admin.getEntity("Prices"))
            .targetField(nga.field("name"))
            .label("Name"),
          nga
            .field("price_id", "reference")
            .targetEntity(admin.getEntity("Prices"))
            .targetField(nga.field("price_per_day"))
            .label("Day"),
          nga
            .field("price_id", "reference")
            .targetEntity(admin.getEntity("Prices"))
            .targetField(nga.field("price_per_month"))
            .label("Month"),
          nga
            .field("price_id", "reference")
            .targetEntity(admin.getEntity("Prices"))
            .targetField(nga.field("price_per_three_months"))
            .label("Three Months"),
          nga
            .field("price_id", "reference")
            .targetEntity(admin.getEntity("Prices"))
            .targetField(nga.field("price_per_six_months"))
            .label("Six Months"),
          nga
            .field("price_id", "reference")
            .targetEntity(admin.getEntity("Prices"))
            .targetField(nga.field("price_per_year"))
            .label("Year"),
        ])
        .listActions([
          '<ma-delete-button label="Remove" entry="entry" entity="entity" size="xs"></ma-delete-button>',
        ]),
      nga
        .field("ADD PRICE", "template")
        .label("")
        .template(
          '<ma-create-button entity-name="comboPrices" class="pull-right" label="ADD PRICE" default-values="{ combo_id: entry.values.id }"></ma-create-button>'
        ),
      nga
        .field("", "referenced_list")
        .label("Packages")
        .targetEntity(admin.getEntity("comboPackages"))
        .targetReferenceField("combo_id")
        .targetFields([
          nga
            .field("package_id", "reference")
            .targetEntity(admin.getEntity("Packages"))
            .targetField(nga.field("package_name"))
            .label("Package"),
          nga
            .field("package_id", "reference")
            .targetEntity(admin.getEntity("Packages"))
            .targetField(
              nga.field("package_type").map(function getpckdes(value, entry) {
                return entry["package_type.description"];
              })
            )
            .label("Package Type"),
        ])
        .listActions([
          '<ma-delete-button label="Remove" entry="entry" entity="entity" size="xs"></ma-delete-button>',
        ]),
      nga
        .field("ADD PACKAGE", "template")
        .label("")
        .template(
          '<ma-create-button entity-name="comboPackages" class="pull-right" label="ADD PACKAGE" default-values="{ combo_id: entry.values.id }"></ma-create-button>'
        ),
      nga
        .field("", "referenced_list")
        .label("Channels")
        .targetEntity(admin.getEntity("comboChannels"))
        .targetReferenceField("combo_id")
        .targetFields([
          nga
            .field("channel_id", "reference")
            .targetEntity(admin.getEntity("Channels"))
            .targetField(nga.field("title"))
            .label("Title"),
          nga
            .field("channel_id", "reference")
            .targetEntity(admin.getEntity("Channels"))
            .targetField(nga.field("description"))
            .label("Description"),
        ])
        .listActions([
          '<ma-delete-button label="Remove" entry="entry" entity="entity" size="xs"></ma-delete-button>',
        ]),
      nga
        .field("ADD CHANNEL", "template")
        .label("")
        .template(
          '<ma-create-button entity-name="comboChannels" class="pull-right" label="ADD CHANNEL" default-values="{ combo_id: entry.values.id }"></ma-create-button>'
        ),
    ]);

  return combo;
}



// WEBPACK FOOTER //
// ./js/combo/config.js